import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'as0004',
    ecrans: ['00-2']
});
